// extracted by mini-css-extract-plugin
export default {"textEditor":"TextDisplay_textEditor__8CONz","textField":"TextDisplay_textField__HXAsV","standardNotes":"TextDisplay_standardNotes__K2A0X"};